import { Build, Step } from "~/components/build/Show/lib/types";
import { QueryClient, queryOptions, UseQueryOptions } from "@tanstack/react-query";
import fetcher from "~/components/build/Show/lib/fetcher";

export const stepQueryKey = (buildId: Build["id"], stepUuid: Step["uuid"]) => {
  return ["build", buildId, "steps", stepUuid];
};

export const stepQueryOptions = (
  build: Build,
  stepUuid: Step["uuid"],
  queryOptionsArgs: Omit<UseQueryOptions<Step>, "queryKey" | "queryFn"> = {},
) => {
  return queryOptions({
    queryKey: stepQueryKey(build.id, stepUuid),
    queryFn: ({ signal }) => fetchStep(build.buildDataBasePath, stepUuid, signal),
    ...queryOptionsArgs,
  });
};

export const setStepQueryData = (buildId: Build["id"], step: Step, queryClient: QueryClient) => {
  queryClient.setQueryData(stepQueryKey(buildId, step.uuid), step);
};

function fetchStep(
  buildDataBasePath: Build["buildDataBasePath"],
  stepUuid: Step["uuid"],
  signal: AbortSignal,
): Promise<Step> {
  const url = new URL(`${buildDataBasePath}/steps`, window.location.origin);
  url.searchParams.set("uuid", stepUuid);

  return fetcher<Step[]>(url, true, { signal }).then((response) => {
    const step = response[0];

    if (!step) {
      throw new Error("Step does not exist");
    }

    return step;
  });
}
